import { RootState } from "../../../system/redux/store/community-finder-redux-store";

export const selectWithinRadius = (state: RootState) =>
	state?.mapSettings?.withinRadius;
